<template>
  <div>
    <v-card max-width="800" class="mx-auto mt-5">
      <v-card-title> Buscar Personas </v-card-title>
      <v-card-text>
        <v-row class="ma-1">
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="buscarValor"
              @keyup.enter="buscar"
              hint="Ingrese apellidos y nombres Ej. BORGHETTI CARLO"
              label="Ingrese un valor para buscar"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              v-model="buscarPor"
              label="buscar por"
              :items="items"
              item-text="nombre"
              item-value="propiedad"
              return-object
            />
          </v-col>
        </v-row>
        <v-row class="ma-1" v-if="buscarPor.propiedad == 'nombre_completo'">
          <v-checkbox
            label="Coincidencia exacta"
            v-model="coincidenciaExacta"
          />
        </v-row>
      </v-card-text>
      <span class="red--text">{{ errorMessage }}</span>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="primary" @click="$router.push('/')"> Volver </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="buscar" color="primary">Buscar</v-btn>
      </v-card-actions>
    </v-card>

    <v-card
      max-width="1200"
      class="mx-auto mt-5"
      v-if="unirPersonas.length != 2"
    >
      <v-card-title>
        <v-text-field
          v-if="personas.length > 0"
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="personas" :search="search">
        
        <template v-slot:[`item.nombreCompleto`]="props">
           <Ficha :persona="props.item" />          
        </template>
        <template v-slot:[`item.action`]="props">
          <v-btn
            v-if="
              $store.getters.user.roles.includes('UNIFICARPERSONA') &&
              unirPersonas.length < 2
            "
            small
            color="warning"
            @click="unir(props.item)"
            >Unir</v-btn
          >
          <Distribuciones :personaId="props.item.id" />
          <OrdenesPagos :liquidacionId="null" :beneficiarioId="props.item.id" />
        </template>
      </v-data-table>

      <v-card-actions> </v-card-actions>
    </v-card>

    <v-card v-if="unirPersonas.length > 0">
      <v-card-title> UNIFICAR PERSONAS </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Id</th>
              <th class="text-left">Nombres</th>
              <th class="text-left">IP</th>
              <th class="text-left">Codigo SGS</th>
              <th class="text-left">Codigo Gestion</th>
              <th class="text-left">Cedula</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="persona in unirPersonas"
              :key="persona.id"
              :class="{ eliminar: persona.eliminar }"
            >
              <td>{{ persona.id }}</td>
              <td>{{ persona.nombreCompleto }}</td>
              <td>{{ persona.ipName }}</td>
              <td>{{ persona.codMemSq }}</td>
              <td>{{ persona.gestionIdSocio }}</td>
              <td>{{ persona.cedula }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions>
        <v-btn color="primary" @click="unirPersonas = []">CANCELAR</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" v-if="unirPersonas.length == 2" @click="invertirSeleccion"
          >INVERTIR SELECCION</v-btn
        >
        <v-spacer></v-spacer>
        <Confirmar
          v-if="unirPersonas.length == 2"
          :disabled="!unirPersonas[0].codMemSq"
          @si="unificarPersonas"
          titulo="proceder a unificar personas"
          texto="Esta opción no se puede deshacer. <br> <b>¿desea continuar?</b>"
          color="primary"
          @click="unirPersonas = []"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import Distribuciones from "./Distribuciones.vue";
import OrdenesPagos from "./OrdenesPagos.vue";
import Confirmar from "@/components/Confirmar.vue";
import Ficha from "@/components/ficha/Ficha.vue";

export default {
  data() {
    return {
      search: "",
      buscarValor: "",
      unirPersonas: [],
      buscarPor: { propiedad: "nombre_completo", nombre: "nombres" },
      coincidenciaExacta: false,
      items: [
        { propiedad: "nombre_completo", nombre: "Apellidos y Nombres" },
        { propiedad: "codigoSGS", nombre: "Código de SGS" },
        { propiedad: "codigoGESTION", nombre: "Código de GESTIÓN" },
        { propiedad: "ip", nombre: "IP" },
        { propiedad: "cedula", nombre: "Número de Cédula" },
      ],
      headers: [
        { text: "Id", value: "id" },
        { text: "Codigo SGS", value: "codMemSq" },
        { text: "Nombres", value: "nombreCompleto" },
        { text: "IP", value: "ipName" },
        { text: "Codigo Gestion", value: "gestionIdSocio" },
        { text: "Cedula", value: "cedula" },
        { text: "Tipo Socio", value: "memType" },
        { text: "", value: "action" },
      ],
      personas: [],
      errorMessage: "",
    };
  },
  methods: {
    buscar() {
      this.errorMessage = "";
      if (this.buscarValor.trim() == "") {
        this.errorMessage = "Ingrese un valor para buscar";
        return;
      }

      let valor = this.buscarValor.trim();

      if (
        !this.coincidenciaExacta &&
        this.buscarPor.propiedad == "nombre_completo"
      ) {
        valor = `%${this.buscarValor.replace(" ", "%")}%`;
      }

      axios
        .get("/persona/buscar", {
          params: {
            valor: valor,
            propiedad: this.buscarPor.propiedad,
          },
        })
        .then((res) => {
          this.personas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    unir(persona) {
      if (this.unirPersonas.filter((row) => row.id == persona.id).length > 0) {
        return;
      }
      if (this.unirPersonas.length == 0) {
        this.unirPersonas.push({ eliminar: false, ...persona });
      } else {
        this.unirPersonas.push({ eliminar: true, ...persona });
      }
      this.personas = this.personas.filter((row) => row.id != persona.id);
    },
    unificarPersonas() {
      this.mensajeError = "";
      axios
        .patch(
          `/persona/unificar?personaId=${this.unirPersonas[0].id}&personaIdEliminar=${this.unirPersonas[1].id}`
        )
        .then((res) => {
          console.log(res);
          this.unirPersonas = [];
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    invertirSeleccion() {
      this.unirPersonas = this.unirPersonas.reverse();
      this.unirPersonas.forEach(p => p.eliminar = !p.eliminar)
    }
  },
  components: {
    Distribuciones,
    OrdenesPagos,
    Confirmar,
    Ficha,
  },
};
</script>

<style  scoped>
.eliminar {
  color: red;
  text-decoration: line-through;
}
</style>